import React from 'react';
import InfoTooltip, { OPEN_MARKET_TRADES_TOOLTIP } from '../InfoTooltip/InfoTooltip';

const OpenMarketTradesInfoTooltip = () => (
  <InfoTooltip text={OPEN_MARKET_TRADES_TOOLTIP} label="About open-market trades" />
);

export default OpenMarketTradesInfoTooltip;
